'use client'

import React from 'react'
import { useTravelComparatorStore } from '@/app/stores/travel/travel-comparator.store'
import { destinationOptionsFor, RESIDENCE_OPTIONS, today } from '../travelFormConfig'
import CountryCell from './CountryCell'
import TravelDateRangeField from './TravelDateRangeField'
import TravelersCell from './TravelersCell'

export default function TravelTripFields() {
    const { form, patchForm } = useTravelComparatorStore()

    return (
        <div className="flex flex-col gap-2.5 sm:gap-3">
            <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 sm:gap-3">
                <CountryCell
                    label="Pays de résidence"
                    placeholder="Votre pays"
                    value={form.residenceCountry}
                    options={RESIDENCE_OPTIONS}
                    onChange={(code) => patchForm({ residenceCountry: code })}
                />
                <CountryCell
                    label="Destination"
                    placeholder="Où allez-vous ?"
                    multiple
                    value={form.destinationCountries}
                    options={destinationOptionsFor(form.motif)}
                    onChange={(codes) => patchForm({ destinationCountries: codes })}
                />
            </div>
            {/* Colonne des dates un peu plus large : « 01/10/2026 → 01/05/2027 » (190 px) ne tient pas dans une
                moitié de la carte de 560 px en desktop (172 px utiles), et « 3 adultes, 2 enfants » (136 px)
                garde sa place à droite. La ligne résidence/destination reste en deux moitiés. */}
            <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-[1.25fr_1fr] sm:gap-3">
                <TravelDateRangeField
                    startDate={form.startDate}
                    endDate={form.endDate}
                    minDate={today()}
                    onChange={(startDate, endDate) => patchForm({ startDate, endDate })}
                />
                <TravelersCell />
            </div>
        </div>
    )
}
